import React, { ChangeEvent, FormEvent } from 'react';
import Modal from 'react-modal';

import ModalBackground from '../atoms/ModalBackground';
import ButtonContainer from '../atoms/ButtonContainer';
import Button from '../atoms/Button';
import ButtonLabel from '../atoms/ButtonLabel';
import InputForm from '../molecules/InputForm';
import i18n from '../R/string/i18n';
import ErrorBox from '../organisms/ErrorBox';

type Props = {
  type: 'google' | 'facebook';
  title: string;
  isOpen: boolean;
  disabled: boolean;
  email: string;
  emailErr: string | undefined;
  serverErr: string;
  onChangeEmail: (e: ChangeEvent<HTMLInputElement>) => void;
  onSubmitSignUp: (event: FormEvent<HTMLFormElement>) => void;
  onRequestClose: () => void;
};

const onOpen = () => {
  document.body.style.overflow = 'hidden';
};

const onClose = () => {
  document.body.style.overflow = 'visible';
};

const EmailConfirmationModal = (props: Props) => {
  const onFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    props.onSubmitSignUp(e);
  };

  const modalStyles = {
    overlay: {
      zIndex: 3,
      backgroundColor: 'rgba(0, 0, 0, 0.75)'
    },
    content: {
      backgroundColor: 'transparent',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      padding: 0,
      border: 'none',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  };

  const buttonLabel =
    props.type === 'google'
      ? i18n.socialLoginSignUpWithGoogle()
      : i18n.socialLoginSignUpWithFacebook();

  return (
    <Modal
      isOpen={props.isOpen}
      style={modalStyles}
      onAfterClose={onClose}
      onAfterOpen={onOpen}
    >
      <ModalBackground>
        <ErrorBox message={props.serverErr} />
        <p>{props.title}</p>
        <form onSubmit={onFormSubmit}>
          <InputForm
            label={i18n.commonEmail()}
            type="email"
            disabled={props.disabled}
            value={props.email}
            onChange={props.onChangeEmail}
            errorMessage={props.emailErr}
          />
          <ButtonContainer>
            <Button type="submit">
              <ButtonLabel>{buttonLabel}</ButtonLabel>
            </Button>
          </ButtonContainer>
        </form>
      </ModalBackground>
    </Modal>
  );
};

EmailConfirmationModal.defaultProps = {
  disabled: false
};

export default EmailConfirmationModal;
